  
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { GetPartnersResponse, Params } from "../../types/Types";

export function useGetPartners({
  enabled = true,
  pageSize = 10,
  page = 1,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ['partners', { pageSize, page }],
    queryFn: async () => {
      const url = getAPIURL(`/Partner/All?pageNumber=${page}&pageSize=${pageSize}`);
      return axiosInstance<GetPartnersResponse>(url).then((res) => res.data);
    },
  });
}